export default __webpack_public_path__ + "pdfjs-dist-ie11-ledge/pdf.min-2e6103c831c1a21fe744afcc382c3659.js";